// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-foot {
    display: none;
}

.sr-only {
    display: none;
}

.react-bs-table-no-data {
    text-align: center;
}

.export-container {
    text-align: end;
}
.search-student {
    display: grid;
}

.add-student {
    margin-right: 5px;
}

.search-result {
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/CourseStudent/CourseStudent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".table-foot {\n    display: none;\n}\n\n.sr-only {\n    display: none;\n}\n\n.react-bs-table-no-data {\n    text-align: center;\n}\n\n.export-container {\n    text-align: end;\n}\n.search-student {\n    display: grid;\n}\n\n.add-student {\n    margin-right: 5px;\n}\n\n.search-result {\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
